import React, { useEffect } from "react";
import "./App.css";
import Hero from "./components/hero";
import { ProjectCard } from "./components/project-card/projectCard";
import { Skills } from "./components/skills";
import Footer from "./components/footer";
import Contact from "./components/Contact";
import About from "./components/About";
import projects from "./components/Projects.json";

function App() {
  useEffect(() => {
    const handleAnchorClick = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute("href").slice(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const scrollTo = targetElement.offsetTop;
        window.scrollTo({
          top: scrollTo,
          behavior: "smooth",
        });
      }
    };

    const anchorLinks = document.querySelectorAll(".js-anchor-link");
    anchorLinks.forEach((link) => {
      link.addEventListener("click", handleAnchorClick);
    });

    return () => {
      anchorLinks.forEach((link) => {
        link.removeEventListener("click", handleAnchorClick);
      });
    };
  }, []);

  return (
    <>
      <Hero />
      <About />
      <div id="Project" className="project-div">
        <div className="flex flex-col items-center justify-center w-full">
          <p className="cursive title-top">Projects</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-1">
            {projects.map((value, index) => (
              <ProjectCard
                linkWeb={value.githubLink}
                tittle={value.name}
                subtittle={value.tagline}
                description={value.description}
                languages={value.lang}
              />
            ))}
          </div>
        </div>
      </div>
      <Skills />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
